import { useMemo } from 'react';
import { FiMoreVertical } from 'react-icons/fi';
import { DropdownProvider } from '@/components/core-components/StanDropdown/DropdownProvider';
import { StanDropdownMenu } from '@/components/core-components/StanDropdown/Menu/StanDropdownMenu';
import type { DropdownMenuOption, DropdownValue } from '@/components/core-components/StanDropdown/StanDropdown.types';
import type { SectionItem } from '../types/myStore.types';
import IcEdit from '@/assets/icons/ic-edit-01.svg';
import IcTrash from '@/assets/icons/ic-trash.svg';

export interface SectionActionsMenuProps {
    item: SectionItem;
    onEdit?: () => void;
    onDelete?: () => void;
}

export function SectionActionsMenu({ item, onEdit, onDelete }: SectionActionsMenuProps) {
    const menuOptions = useMemo((): DropdownMenuOption[] => {
        const options: DropdownMenuOption[] = [];

        options.push({
            label: 'Edit Section',
            value: 'edit',
            icon: IcEdit,
        });

        options.push({
            label: '',
            value: 'divider-1',
            type: 'divider',
        });

        options.push({
            label: 'Delete Section',
            value: 'delete',
            icon: IcTrash,
            type: 'destructive',
        });

        return options;
    }, []);

    const handleSelect = (value: DropdownValue) => {
        switch (value.value) {
            case 'edit':
                onEdit?.();
                break;
            case 'delete':
                onDelete?.();
                break;
        }
    };

    return (
        <DropdownProvider dropdownId={`section-menu-${item.id}`} dropdownName={`section-menu-${item.id}`}>
            <StanDropdownMenu
                id={`section-menu-${item.id}`}
                name={`section-menu-${item.id}`}
                options={menuOptions}
                placement='bottom-end'
                onSelect={handleSelect}
                currentValue={null}
                minWidth={200}
            >
                <FiMoreVertical className='text-gray hover:text-dark size-5 cursor-pointer' />
            </StanDropdownMenu>
        </DropdownProvider>
    );
}
